import { addError, removeError } from '@core/utils/error-functions';
function contactItemValueDuplicated(contactItemsArray, itemName, nameField) {
    contactItemsArray.controls.forEach(function (contactItemForm) {
        var itemsWithSameNumber = contactItemsArray.controls.filter(function (anotherItemForm) {
            return anotherItemForm.value[nameField] === contactItemForm.value[nameField];
        });
        itemsWithSameNumber.forEach(function (control) {
            var isDuplicated = itemsWithSameNumber.length > 1;
            var nameControl = control.get(nameField);
            var nameControlCamelCase = nameField[0].toUpperCase() + nameField.slice(1);
            if (isDuplicated) {
                addError(nameControl, "" + itemName + nameControlCamelCase + "Duplicated");
            }
            else {
                removeError(nameControl, "" + itemName + nameControlCamelCase + "Duplicated");
            }
        });
    });
    return null;
}
var ContactItemValidator = /** @class */ (function () {
    function ContactItemValidator() {
    }
    ContactItemValidator.phoneNumberDuplicated = function (contactPhonesArray) {
        return contactItemValueDuplicated(contactPhonesArray, 'phone', 'number');
    };
    ContactItemValidator.emailAddressDuplicated = function (contactEmailsArray) {
        return contactItemValueDuplicated(contactEmailsArray, 'email', 'emailAddress');
    };
    return ContactItemValidator;
}());
export { ContactItemValidator };
